import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import { AUTH_TOKEN } from "store/auth/login/actionTypes";
import history from "../history";

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

// Config
const ENTRY_ROUTE = "/login";
const TOKEN_PAYLOAD_KEY = "authorization";
const PUBLIC_REQUEST_KEY = "public-request";
const ACCESS_CONTROL_ALLOW_ORIGIN = "access-control-allow-origin";

// API Request interceptor
service.interceptors.request.use(
  config => {
    const jwtToken = "Bearer " + localStorage.getItem(AUTH_TOKEN);
    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = jwtToken;
    }
    if (!jwtToken && !config.headers[PUBLIC_REQUEST_KEY]) {
      history.push(ENTRY_ROUTE);
      window.location.reload();
    }

    return config;
  },
  error => {
    // Do something with request error here
    // notification.error({
    //   message: "Error",
    // });
    Promise.reject(error);
  }
);

// API respone interceptor
service.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    let notificationParam = {
      message: "",
    };

    const isRunnerScheduleChanges =
      error.config?.url?.includes("/runner-schedule-changes/") &&
      (error.config?.method === "delete" || error.config?.method === "put");

    const isCollectorScheduleChanges =
      error.config?.url?.includes("/collector-schedule-changes/") &&
      (error.config?.method === "delete" || error.config?.method === "put");

    const isScheduleChanges =
      isRunnerScheduleChanges || isCollectorScheduleChanges;

    // Remove token and redirect
    if (
      error.response.status === 400 ||
      error.response.status === 403 ||
      error.response.status === 401
    ) {
      if (isScheduleChanges && error.response?.status === 400) {
        return Promise.reject(error);
      }

      notificationParam.message = "Authentication Fail";
      notificationParam.description = "Please login again";
      localStorage.removeItem(AUTH_TOKEN);
      history.push(ENTRY_ROUTE);
      window.location.reload();
    }

    if (error.response.status === 404) {
      notificationParam.message = "Not Found";
    }

    if (error.response.status === 500) {
      notificationParam.message = "Internal Server Error";
    }

    if (error.response.status === 508) {
      notificationParam.message = "Time Out";
    }

    // notification.error(notificationParam);

    return Promise.reject(error);
  }
);

export default service;
